import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Journey } from "@/components/Journey";
import { WhyTurkiye } from "@/components/WhyTurkiye";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const { hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    let cancelled = false;
    const timers = [];

    const attempt = (n) => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (!el) {
        if (n < 6) timers.push(setTimeout(() => attempt(n + 1), 200));
        return;
      }
      if (lenis) {
        lenis.resize();
        lenis.scrollTo(el, { offset: 0, force: true, duration: 1.1 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
      if (n < 4) {
        timers.push(
          setTimeout(() => {
            if (cancelled) return;
            const top = el.getBoundingClientRect().top;
            if (Math.abs(top - 80) > 160) attempt(n + 1);
          }, 700)
        );
      }
    };

    timers.push(setTimeout(() => attempt(0), 150));
    return () => {
      cancelled = true;
      timers.forEach(clearTimeout);
    };
  }, [hash, lenis]);

  return (
    <div className="bg-[#F7F6F2]">
      <Navbar />
      <Hero />
      <Ribbon />
      <About />
      <Services />
      <Journey />
      <WhyTurkiye />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
